import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
  ContainerTypes,
  FilterCardData,
  GeneralFilter,
  Service,
  ServiceOrder,
  TableColumn,
  ToastConfig,
  SortDirection,
  ConfirmationModalComponent,
  ConfirmationModalConfig,
  ContainerAdvancedSearchState
} from '@app/shared';
import {ProjectSortService} from '../../services/project-sort.service';
import {ProjectUtilsService} from '../../services/project-utils.service';
import {ProjectService, ScreenService} from '@app/core';
import {ProjectContainer} from '../../../../shared/models/project-container';
import {NzDrawerService} from 'ng-zorro-antd/drawer';
import {NzModalService} from 'ng-zorro-antd/modal';
import {combineLatest, finalize, merge, take} from 'rxjs';
import {GlobalValuesService} from '../../../../core/services/global-values.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ContainerDetailDrawerComponent} from '../../drawers/container-detail-drawer/container-detail-drawer.component';
import {ContainerCreateDrawerComponent} from '../../drawers/container-create-drawer/container-create-drawer.component';
import {ContainerAdvancedSearchComponent} from '../../../../shared/components/container-advanced-search/container-advanced-search.component';
import {ContainerAdvancedSearchMatch} from '../../../../shared/models/container-advanced-search';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {Router} from '@angular/router';
import {AuthService} from '../../../../core/services/auth.service';
import {Subject, takeUntil} from 'rxjs';

interface FilterValues {
  containerTypeFilterValue: any;
  serviceFilterValue: any;
  serviceOrderFilterValue: any;
}

type FilterMap = {
  [key: string]: keyof FilterValues;
};

@Component({
  selector: 'app-container-section',
  standalone: false,

  templateUrl: './container-section.component.html',
  styleUrl: './container-section.component.less'
})
export class ContainerSectionComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  loading: boolean = false;

  /** Variables de filtrado **/
  totalUsedContainers: number = 0;
  totalFreeContainers: number = 0;

  cardsFilters: FilterCardData[] = [
    {
      label: 'Contenedores',
      active: false,
    },
    {
      label: 'Contenedores usados',
      active: false,
    },
    {
      label: 'Contenedores disponibles',
      active: false,
    },
  ];
  generalFilters: GeneralFilter[] = [
    {
      name: 'Tipo',
      active: false,
      icon: 'arrow_drop_down',
      value: undefined,
    },
    // {
    //   name: 'Servicio',
    //   active: false,
    //   icon: 'arrow_drop_down',
    //   value: undefined,
    // },
    // {
    //   name: 'Orden',
    //   active: false,
    //   icon: 'arrow_drop_down',
    //   value: undefined,
    // },
  ];
  searchValue: string = '';
  containerTypeFilterValue: ContainerTypes | undefined;
  serviceFilterValue: Service | undefined;
  serviceOrderFilterValue: ServiceOrder | undefined;
  containerTypeList: ContainerTypes[] = [];
  containerTypeAvailable: ContainerTypes[] = [];
  serviceList: Service[] = [];
  serviceOrderList: ServiceOrder[] = [];
  /** Variables de tabla **/
  columns: TableColumn[] = [
    {
      name: '',
      width: '65',
      checkbox: true,
      align: 'center'
    },
    {
      name: 'Referencia Contenedor',
      pathData: { name: 'containerRef', type: 'text' },
      width: '224',
      align: 'left',
    },
    {
      name: 'Tipo',
      pathData: { name: 'containerType.description', type: 'text' },
      align: 'left'
    },
    // {
    //   name: 'Servicio',
    //   width: '224',
    //   align: 'left'
    // },
    // {
    //   name: 'Orden de Servicio',
    //   align: 'left'
    // },
  ];
  filteredContainers: ProjectContainer[] = [];
  /** Paginación **/
  pageIndex = 1;
  pageSize = 10;
  pageSizeOptions = [10, 50, 100, 200, 500];
  /** Variables de seleccion **/
  selectedContainerIds = new Set<number>();
  isIndeterminate: boolean = false;
  isAllSelected: boolean = false;
  detailDrawerRef: any;
  createDrawerRef: any;
  containerAdvancedSearchDrawerRef: any;
  applyModeModalRef: any;
  clearModalRef: any;
  private pendingFoundContainerRefs: string[] = [];
  private pendingClearDrawerCmp: ContainerAdvancedSearchComponent | null = null;
  advancedContainerRefs: string[] = [];
  advancedContainerCombineWithCurrentFilters = false;
  advancedSearchDrawerState: ContainerAdvancedSearchState = this.createInitialAdvancedSearchState();
  /** Variables de feedback **/
  toastConfig: ToastConfig = {
    icon: 'check_circle',
    iconColor: '#6CDA75',
    content: 'Proyecto creado',
    showUndo: false
  };
  notRef: any;
  @ViewChild('notificationTmpl') notificationTmpl: any;
  @ViewChild('confirmationModal') confirmationModal!: ConfirmationModalComponent;
  @ViewChild('applyModeModalTitleTmpl') applyModeModalTitleTmpl: any;
  @ViewChild('applyModeModalContentTmpl') applyModeModalContentTmpl: any;
  @ViewChild('applyModeModalFooterTmpl') applyModeModalFooterTmpl: any;
  @ViewChild('clearModalTitleTmpl') clearModalTitleTmpl: any;
  @ViewChild('clearModalContentTmpl') clearModalContentTmpl: any;
  @ViewChild('clearModalFooterTmpl') clearModalFooterTmpl: any;
  private pendingDeleteId?: number;
  // Mapa de filtros con tipado seguro
  private readonly filterValueMap: FilterMap = {
    'Tipo': 'containerTypeFilterValue',
    'Servicio': 'serviceFilterValue',
    'Orden': 'serviceOrderFilterValue'
  };

  constructor(
    public ps: ProjectUtilsService,
    public gs: GlobalValuesService,
    public screenService: ScreenService,
    public authService: AuthService,
    private projectService: ProjectService,
    private drawerService: NzDrawerService,
    private modalService: NzModalService,
    private notificationService: NzNotificationService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private projectSortService: ProjectSortService,
  ) {
    gs.containerTypes$.pipe(takeUntilDestroyed())
      .subscribe(value => this.containerTypeList = value);
  }

  ngOnInit() {
    this.loading = true;
    // this.setFilterData();
    this.filter();
    this.configureSortFunctions();

    this.loading = false;
  }

  /** Logica de seleccion de Equipos **/
  //region Seleccion
  // Alternamiento individual
  toggleSelectContainer(id: number): void {
    const newSet = new Set(this.selectedContainerIds);

    if (newSet.has(id)) {
      newSet.delete(id);
    } else {
      newSet.add(id);
    }

    this.selectedContainerIds = newSet;
    this.updateSelectionState(); // Actualizar estados después de cambiar
  }

  // Alternamiento total
  toggleSelectAllContainer(): void {
    const shouldSelectAll = !this.isAllSelected;
    const newSet = new Set<number>();

    if (shouldSelectAll) {
      // Solo se marcan los libres
      this.filteredContainers.forEach(item => {
        newSet.add(item.id);
      });
    }

    this.selectedContainerIds = newSet;
    this.updateSelectionState(); // Actualizar estados después de cambiar
  }

  updateSelectionState(): void {
    const activeItems = this.filteredContainers;
    const activeCount = activeItems.length;
    const selectedCount = activeItems.filter(item =>
      this.selectedContainerIds.has(item.id)
    ).length;

    this.isAllSelected = activeCount > 0 && selectedCount === activeCount;
    this.isIndeterminate = selectedCount > 0 && selectedCount < activeCount;
  }

  //endregion

  /** Metodos de drawers **/
  //region Drawers
  openContainerCreateDrawer(isCreateContainer: boolean) {

    const selectedIds = Array.from(this.selectedContainerIds);

    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    }).pipe(take(1)).subscribe(({isMobile, isMedium}) => {
      this.createDrawerRef = this.drawerService.create({
        nzClosable: false,
        nzMask: true,
        nzWidth: 793,
        nzHeight: '98%',
        nzPlacement: isMobile ? 'bottom' : 'right',
        nzContent: ContainerCreateDrawerComponent,
        nzData: {
          containers: this.ps.selectedProject!.projectContainers!.filter(c => selectedIds.includes(c.id)) || [],
          isCreateContainer,
          containerTypes: this.containerTypeList,
        }
      });

      this.createDrawerRef.afterOpen.pipe(take(1)).subscribe(() => {
        this.createDrawerRef.getContentComponent().updateContainers.pipe(take(1))
          .subscribe(() => {
            this.ngOnInit();
          });
      })
    });
  }

  openContainerDetailDrawer(container: ProjectContainer, readonly: boolean) {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    }).pipe(take(1)).subscribe(({isMobile, isMedium}) => {
      this.detailDrawerRef = this.drawerService.create({
        nzClosable: false,
        nzMask: false,
        nzWidth: 635,
        nzHeight: '98%',
        nzPlacement: isMobile ? 'bottom' : 'right',
        nzContent: ContainerDetailDrawerComponent,
        nzData: {
          container,
          readonly,
        }
      });

      this.detailDrawerRef.afterOpen.pipe(take(1)).subscribe(() => {
        this.detailDrawerRef.getContentComponent().updateContainer.pipe(take(1))
          .subscribe((value: ProjectContainer) => {
            this.ps.selectedProject!.projectContainers = this.ps.selectedProject!.projectContainers!
              .map(p => p.id === value.id ? value : p);
            this.filter();
            this.cdr.detectChanges();
          });
      })
    });
  }

  openContainerAdvancedSearchDrawer(): void {
    this.containerAdvancedSearchDrawerRef?.close();
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    }).pipe(take(1)).subscribe(({isMobile}) => {
      this.containerAdvancedSearchDrawerRef = this.drawerService.create({
        nzWidth: 900,
        nzHeight: '98%',
        nzPlacement: isMobile ? 'bottom' : 'right',
        nzClosable: false,
        nzMask: true,
        nzContent: ContainerAdvancedSearchComponent,
        nzData: {
          title: 'Búsqueda avanzada de contenedores',
          resolveMatches: (containerRefs: string[]) => this.resolveContainerMatchesForAdvancedSearch(containerRefs),
          initialState: this.advancedSearchDrawerState,
          section: 'containers',
        }
      });

      this.containerAdvancedSearchDrawerRef.afterOpen.pipe(take(1)).subscribe(() => {
        const drawerCmp = this.containerAdvancedSearchDrawerRef.getContentComponent();
        drawerCmp.applyFound
          .pipe(takeUntil(merge(this.containerAdvancedSearchDrawerRef.afterClose, this.destroy$)))
          .subscribe((foundContainerRefs: string[]) => this.askApplyModeForAdvancedSearch(foundContainerRefs));
        drawerCmp.clearAppliedRequest
          .pipe(takeUntil(merge(this.containerAdvancedSearchDrawerRef.afterClose, this.destroy$)))
          .subscribe(() => this.confirmClearAdvancedContainerFilter(drawerCmp));
        drawerCmp.stateChanged
          .pipe(takeUntil(merge(this.containerAdvancedSearchDrawerRef.afterClose, this.destroy$)))
          .subscribe((state: ContainerAdvancedSearchState) => {
            this.advancedSearchDrawerState = {
              searchInput: state.searchInput,
              rows: [...state.rows],
              summary: {...state.summary},
              searched: state.searched,
            };
          });
      });
    });
  }

  private async resolveContainerMatchesForAdvancedSearch(containerRefs: string[]): Promise<ContainerAdvancedSearchMatch[]> {
    const normalizedRefs = [...new Set(
      containerRefs.map(ref => ref.trim().toUpperCase()).filter(Boolean)
    )];
    if (normalizedRefs.length === 0 || !this.ps.selectedProject?.projectContainers?.length) {
      return [];
    }
    const refSet = new Set(normalizedRefs);
    const containers = this.ps.selectedProject.projectContainers.filter(
      c => refSet.has((c.containerRef || '').trim().toUpperCase())
    );
    return containers.map(c => {
      const so = c.serviceOrder;
      const stateData = so ? this.getServiceOrderStateBadge(so) : {name: '-', class: 'subtle-grey', icon: ''};
      const eventDate = so ? this.getCurrentEventDateForAdvanced(so) : null;
      const formattedEventDate = eventDate
        ? eventDate.toLocaleString('es-CL', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        }).toUpperCase()
        : '-';
      return {
        containerNumber: (c.containerRef || '').trim().toUpperCase(),
        currentStatus: stateData.name,
        currentStatusClass: stateData.class,
        currentStatusIcon: stateData.icon,
        lastEventDate: formattedEventDate,
        referenceOrder: so?.reference || so?.referenceCEC || (so?.id ? `SO-${so.id}` : '-'),
        containerTypeCode: c.containerType?.code || '-',
      };
    });
  }

  private getCurrentEventDateForAdvanced(serviceOrder: ServiceOrder): Date | null {
    const candidate = serviceOrder.events?.[serviceOrder.events.length - 1];
    if (!candidate) return null;
    const rawDate = (candidate as any).integrationField ? (candidate as any).integrationValue : (candidate as any).dateTime;
    return rawDate ? new Date(rawDate) : null;
  }

  private getServiceOrderStateBadge(serviceOrder: ServiceOrder): { name: string; class: string; icon: string } {
    const events = serviceOrder.flow?.events || [];
    const event = events.find(e => e.id.toString() === serviceOrder.state);
    if (!event) return {name: 'Sin estado', class: 'subtle-grey', icon: ''};
    let color = event.color || '#A8A8A8';
    if (event.name === 'Orden creada') color = '#FF990A';
    if (event.name === 'Orden finalizada') color = '#45A557';
    return {
      name: event.name || 'Sin estado',
      class: this.getStateClassByColor(color),
      icon: event.icon || '',
    };
  }

  private getStateClassByColor(color: string): string {
    switch (color) {
      case '#0072F5': return 'subtle-blue';
      case '#A8A8A8': return 'subtle-grey';
      case '#8E4EC6': return 'subtle-purple';
      case '#FF990A': return 'subtle-amber';
      case '#E5484D': return 'subtle-red';
      case '#EA3E83': return 'subtle-pink';
      case '#45A557': return 'subtle-green';
      case '#12A594': return 'subtle-teal';
      default: return 'black';
    }
  }

  private askApplyModeForAdvancedSearch(foundContainerRefs: string[]): void {
    if (foundContainerRefs.length === 0) return;
    this.pendingFoundContainerRefs = [...foundContainerRefs];
    this.openApplyModeModal();
  }

  private openApplyModeModal(): void {
    this.applyModeModalRef?.close();
    this.applyModeModalRef = this.modalService.create({
      nzTitle: this.applyModeModalTitleTmpl,
      nzWidth: 518,
      nzContent: this.applyModeModalContentTmpl,
      nzCentered: true,
      nzFooter: this.applyModeModalFooterTmpl,
      nzMaskClosable: false,
      nzClosable: false,
      nzClassName: 'st-modal-unified',
    });
  }

  onApplyModeAction(action: 'cancel' | 'replace' | 'combine'): void {
    if (action === 'combine') {
      this.applyAdvancedContainerFilter(this.pendingFoundContainerRefs, true);
    } else if (action === 'replace') {
      this.applyAdvancedContainerFilter(this.pendingFoundContainerRefs, false);
    }
    this.pendingFoundContainerRefs = [];
    this.applyModeModalRef?.close();
  }

  private applyAdvancedContainerFilter(foundContainerRefs: string[], combineWithCurrentFilters: boolean): void {
    const normalizedRefs = [...new Set(
      foundContainerRefs.map(ref => ref.trim().toUpperCase()).filter(Boolean)
    )];
    this.advancedContainerRefs = normalizedRefs;
    this.advancedContainerCombineWithCurrentFilters = combineWithCurrentFilters;
    if (!combineWithCurrentFilters) {
      this.searchValue = '';
    }
    this.containerAdvancedSearchDrawerRef?.close();
    this.filter();
    this.cdr.detectChanges();
  }

  private confirmClearAdvancedContainerFilter(drawerCmp: ContainerAdvancedSearchComponent): void {
    this.pendingClearDrawerCmp = drawerCmp;
    this.clearModalRef?.close();
    this.clearModalRef = this.modalService.create({
      nzTitle: this.clearModalTitleTmpl,
      nzWidth: 518,
      nzContent: this.clearModalContentTmpl,
      nzCentered: true,
      nzFooter: this.clearModalFooterTmpl,
      nzMaskClosable: false,
      nzClosable: false,
      nzClassName: 'st-modal-unified',
    });
  }

  onClearModalAction(action: 'cancel' | 'limpiar'): void {
    if (action === 'limpiar' && this.pendingClearDrawerCmp) {
      this.clearAdvancedContainerFilterState(true);
      this.pendingClearDrawerCmp.resetState();
    }
    this.pendingClearDrawerCmp = null;
    this.clearModalRef?.close();
  }

  private clearAdvancedContainerFilterState(reload: boolean): void {
    this.advancedContainerRefs = [];
    this.advancedContainerCombineWithCurrentFilters = false;
    this.advancedSearchDrawerState = {
      searchInput: '',
      rows: [],
      summary: {total: 0, found: 0, notFound: 0, invalid: 0},
      searched: false,
    };
    if (reload) {
      this.filter();
      this.cdr.detectChanges();
    }
  }

  private createInitialAdvancedSearchState(): ContainerAdvancedSearchState {
    return {
      searchInput: '',
      rows: [],
      summary: {total: 0, found: 0, notFound: 0, invalid: 0},
      searched: false,
    };
  }

  get hasAdvancedContainerFilterApplied(): boolean {
    return this.advancedContainerRefs.length > 0;
  }

  //endregion

  /** Logica de filtrado **/
  //region Filtrado
  cardFilter(label: string) {
    this.cardsFilters.forEach(c => c.label === label ? c.active = !c.active : c.active = false);
    this.filter();
  }

  onFilterSelect(filterLabel: string, value: any): void {
    // Obtener la propiedad correspondiente al filtro con tipado seguro
    const filterProperty = this.filterValueMap[filterLabel];
    if (!filterProperty) return;

    // Encontrar el filtro actual
    const currentFilter = this.generalFilters.find(f => f.name === filterLabel);
    if (!currentFilter) return;

    // Obtener valor actual usando tipado seguro
    const currentValue = (this as FilterValues)[filterProperty];
    const isSameValue = currentValue === value;

    // Actualizar todos los filtros
    this.generalFilters.forEach(filter => {
      if (filter.name === filterLabel) {
        filter.active = !isSameValue;
        filter.value = isSameValue ? undefined : value;
      } else {
        filter.active = false;
        filter.value = undefined;
      }
    });

    // Actualizar el valor del filtro con tipado seguro
    (this as FilterValues)[filterProperty] = isSameValue ? undefined : value;

    // Aplicar filtros
    this.filter();
  }

  cleanSearch() {
    this.searchValue = '';
    this.filter();
  }

  setFilterData() {
    this.totalUsedContainers = this.ps.selectedProject!.projectContainers!.filter(c => !!c.serviceOrder).length;
    this.totalFreeContainers = this.ps.selectedProject!.projectContainers!.filter(c => !c.serviceOrder).length;

    this.ps.selectedProject!.projectContainers!.forEach(c => {
      if (c.service) {
        this.serviceList.push(c.service);
      }
      if (c.serviceOrder) {
        this.serviceOrderList.push(c.serviceOrder);
      }
    })

  }

  openDeleteConfirmation(id: number) {
    this.pendingDeleteId = id;
    const config: ConfirmationModalConfig = {
      title: 'Eliminar elemento',
      message: '¿Estás seguro que deseas eliminar este elemento?',
      confirmText: 'Eliminar',
      cancelText: 'Cancelar',
      confirmButtonType: 'primary',
      confirmButtonDanger: true
    };
    this.confirmationModal.config = config;
    this.confirmationModal.open();
  }

  onDeleteConfirmed(data: {textValue?: string, dateValue?: Date}) {
    // this.loading = true;
    // Actualizar el estado del modal para mostrar loading
    this.confirmationModal.config.processing = true;
    if (this.pendingDeleteId) {
      this.deleteElement(this.pendingDeleteId);
    }
  }

  deleteElement(id: number) {
    this.projectService.deleteProjectContainer([id])
      .pipe(finalize(() => {
        this.showNotification();
        // this.loading = false;
        this.confirmationModal.config.processing = false;
        this.confirmationModal.forceClose();
      }))
      .subscribe({
        next: () => {
          this.ps.selectedProject!.projectContainers = this.ps.selectedProject!.projectContainers!.filter(c => c.id !== id);
          this.filter();
          this.toastConfig.content = 'El Contenedor ha sido eliminado.';
          this.toastConfig.icon = 'check_circle';
          this.toastConfig.iconColor = '#6CDA75';
        },
        error: (e: any) => {
          console.error(e);
          this.toastConfig.content = 'Ha ocurrido un error eliminando el Contenedor.';
          this.toastConfig.msg = e.error.message;
          this.toastConfig.icon = 'dangerous';
          this.toastConfig.iconColor = '#CB2A2F';
        },
      })
  }

  showNotification(): void {
    this.notRef = this.notificationService
      .create("blank", '', this.notificationTmpl, { nzPlacement: "bottomRight" });
  }

  onPageIndexChange(index: number): void {
    this.pageIndex = index;
    this.cdr.markForCheck();
  }

  onPageSizeChange(size: number): void {
    this.pageSize = size;
    this.pageIndex = 1;
    this.cdr.markForCheck();
  }

  filter() {
    this.pageIndex = 1;
    let tempFilter = this.ps.selectedProject!.projectContainers!;

    this.containerTypeAvailable = tempFilter.reduce((acc: ContainerTypes[], container) => {
      if (container.containerType && !acc.some(ct => ct.id === container.containerType!.id)) {
        acc.push(container.containerType);
      }
      return acc;
    }, []);

    // Contenedores
    if(this.cardsFilters[0]?.active) tempFilter = this.ps.selectedProject!.projectContainers!;

    // Contenedores usados
    if(this.cardsFilters[1]?.active) tempFilter = this.ps.selectedProject!.projectContainers!.filter(c => !!c.serviceOrder);

    // Contenedores disponibles
    if(this.cardsFilters[2]?.active) tempFilter = this.ps.selectedProject!.projectContainers!.filter(c => !c.serviceOrder);

    // Tipo
    this.generalFilters[0]?.active ? tempFilter = tempFilter.filter(c => c.containerType?.id === this.containerTypeFilterValue?.id) : null;

    // Servicio
    this.generalFilters[1]?.active ? tempFilter = tempFilter.filter(c => c.service?.id === this.serviceFilterValue?.id) : null;

    // Orden
    this.generalFilters[2]?.active ? tempFilter = tempFilter.filter(c => c.serviceOrder?.id === this.serviceOrderFilterValue?.id) : null;

    if (this.searchValue) {
      tempFilter = tempFilter.filter(c => c.containerRef?.toLowerCase().includes(this.searchValue.toLowerCase()));
    }

    if (this.advancedContainerRefs.length > 0) {
      const refSet = new Set(this.advancedContainerRefs.map(r => r.trim().toUpperCase()));
      tempFilter = tempFilter.filter(c => refSet.has((c.containerRef || '').trim().toUpperCase()));
    }

    this.filteredContainers = [...tempFilter];
  }

  ngOnDestroy(): void {
    this.containerAdvancedSearchDrawerRef?.close();
    this.applyModeModalRef?.close();
    this.clearModalRef?.close();
    this.destroy$.next();
    this.destroy$.complete();
  }

  //endregion


  openServiceOrderInNewTab(projectId: number, serviceId: number, soRef: number) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(
        ['/projects/detail', projectId, 'service', serviceId],
        {
          queryParams: {
            openServiceOrderDrawer: 'true',
            soRef: soRef.toString()
          }
        }
      )
    );

    window.open(url, '_blank');
  }

  // Métodos de ordenamiento
  private configureSortFunctions(): void {
    this.projectSortService.configureSortFunctions(this.columns, (column) => this.handleSort(column));
  }

  private handleSort(column: TableColumn): void {
    if (!column.pathData) return;

    const { sortedData } = this.projectSortService.handleSort(column, this.filteredContainers, this.columns);
    this.filteredContainers = sortedData;
  }

  getColumnSortDirection(column: TableColumn): SortDirection {
    return column.sortDirection || null;
  }
}
